import { render, staticRenderFns } from "./riskProcessManageDetail.vue?vue&type=template&id=432595ed"
import script from "./riskProcessManageDetail.vue?vue&type=script&lang=js"
export * from "./riskProcessManageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432595ed')) {
      api.createRecord('432595ed', component.options)
    } else {
      api.reload('432595ed', component.options)
    }
    module.hot.accept("./riskProcessManageDetail.vue?vue&type=template&id=432595ed", function () {
      api.rerender('432595ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskProcessManageDetail.vue"
export default component.exports